import { Injectable } from '@angular/core';
import { SealMockApiService, SealNavigationItem } from '@shipsfocus/seal';
import { defaultNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';
import cloneDeep from 'lodash-es/cloneDeep';

@Injectable({
  providedIn: 'root'
})
export class NavigationMockApi {
  private readonly _defaultNavigation: SealNavigationItem[] = defaultNavigation;
  private readonly _horizontalNavigation: SealNavigationItem[] = horizontalNavigation;

  constructor(private _sealMockApiService: SealMockApiService) {
    this.registerHandlers();
  }

  registerHandlers(): void {
    this._sealMockApiService.onGet('api/common/navigation').reply(() => {
      this._horizontalNavigation.forEach((horizontalNavItem) => {
        this._defaultNavigation.forEach((defaultNavItem) => {
          if (defaultNavItem.id === horizontalNavItem.id) {
            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
          }
        });
      });

      return [
        200,
        {
          default: cloneDeep(this._defaultNavigation),
          horizontal: cloneDeep(this._horizontalNavigation)
        }
      ];
    });
  }
}
